import React from "react";
import { AppBar, useLogout } from "react-admin";
import { Button, Toolbar, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

// Desktop navigation lives entirely in the left drawer, matching the Client
// Portal. This compact white bar is only used on phones/tablets.
export default function SupplierAppBar(props) {
  const logout = useLogout();

  return (
    <AppBar
      {...props}
      elevation={0}
      sx={{
        display: { xs: "flex", md: "none" },
        bgcolor: "background.paper",
        color: "text.primary",
        borderBottom: "1px solid",
        borderColor: "divider",
        boxShadow: "none",
        zIndex: 1251,
      }}
    >
      <Toolbar sx={{ width: "100%", minWidth: 0 }}>
        <Typography
          variant="h6"
          id="react-admin-title"
          sx={{ flexGrow: 1, minWidth: 0, fontWeight: 800, fontSize: 16 }}
        >
          Comfort Line Luxury
        </Typography>
        <Button size="small" startIcon={<LogoutIcon />} onClick={() => logout()}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
}
